import authorize from './authorize';
import findProduct from './findProduct';
import syncSelected from './syncSelected';
import cancelSync from './cancelSync';

export default {
  authorize,
  findProduct,
  syncSelected,
  cancelSync,
};



// WEBPACK FOOTER //
// ./src/app/services/vinmonopolet/index.js